import { Box, LinearProgress, linearProgressClasses, Paper, PaperProps, Stack, styled } from "@mui/material";
import { BodyTextM } from "./Typography";

export const ProgressBarListPaper = styled(
    ({ variant = "outlined", ...rest }: PaperProps) => <Paper variant={variant} {...rest} />
)(({ theme }) => theme.unstable_sx({
    p: theme.spacing(4),
}));

export const ProgressBarListItemBox = styled(Box)(({ theme }) => theme.unstable_sx({
    pb: theme.spacing(3),
}));

export const ProgressBarListItemTitleStack = styled(Stack)(({ theme }) => theme.unstable_sx({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
}));

export const ProgressBarListHeading = styled(BodyTextM)(({ theme }) => theme.unstable_sx({
    fontWeight: theme.typography.fontWeightBold
}));

export const ProgressBarListLinearProgress = styled(LinearProgress)(({ theme }) => theme.unstable_sx({
    height: 8,
    my: theme.spacing(3),
    borderRadius: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[100],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 8,
        backgroundColor: theme.palette.primary.main,
    },
}));


